// WhatIsFree.js
// COMMERCIAL TERM UNCONFIRMED: the offer of a free initial consultation is
// inherited from the cloned site. Ivipass has not confirmed it. Confirm or
// remove this section before launch.
import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';

const WhatIsFree = () => {
  const benefits = [
    'A read on your eligibility, given your background',
    'A look at which study or work routes might suit you',
    'What the timings, the requirements and the paperwork really involve',
    'A straight view on whether pursuing it is worth your while'
  ];

  return (
    <section className="py-16 bg-surface">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="max-w-4xl mx-auto">
          {/* Section Header */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="text-center mb-8"
          >
            <h2 className="text-3xl md:text-4xl font-semibold text-primary mb-4">
              No Charge for the First Conversation
            </h2>
          </motion.div>

          {/* Free Consultation Card */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="bg-white p-8 rounded-lg shadow-sm"
          >
            <h3 className="text-xl font-semibold text-primary mb-4">
              The Opening Consultation
            </h3>
            <p className="text-gray-600 text-base font-light leading-relaxed mb-6">
              Before anything is agreed or paid for, we will talk things through with you at no cost, so you can see your options properly.
            </p>

            {/* Benefits List */}
            <div className="mb-6">
              <p className="text-gray-700 text-base font-normal mb-4">
                That conversation covers:
              </p>
              <div className="space-y-3">
                {benefits.map((benefit, index) => (
                  <motion.div
                    key={index}
                    initial={{ opacity: 0, x: -20 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.5, delay: 0.3 + (index * 0.1) }}
                    className="flex items-start gap-3"
                  >
                    <CheckCircle2 size={18} className="text-gray-700 flex-shrink-0 mt-0.5" />
                    <p className="text-gray-700 text-base font-light">
                      {benefit}
                    </p>
                  </motion.div>
                ))}
              </div>
            </div>

            {/* Bottom Note */}
            <p className="text-gray-600 text-sm font-light leading-relaxed">
              Nobody is expected to go any further once that conversation ends.
            </p>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default WhatIsFree;
